"use client";

import { IconForwardArrow } from "@repo/assets/images";
import { ApplePayButton, CheckoutOptionCKO, CheckoutPaymentOptions, CurrencySymbol, PayFortForm, SectionHeading, ShippingTag, StickyButtonWrapper } from "@repo/components";
import { usePayment } from "@repo/lib/hooks/checkout";
import { Button, LoadingDots } from "@repo/ui";
import cx from "classnames";
import { useTranslations } from "next-intl";
import { useEffect, useRef } from "react";
const CheckoutPayment = ({
  selectedAddress,
  paymentMethods,
  locale,
  cart,
  cartRule
}) => {
  const {
    cartTotal
  } = cart;
  const t = useTranslations("Common");
  const formRef = useRef(null);
  const isCkoPayWithFlow = paymentMethods?.some(method => method.code === "CHECKOUT_COM_FLOW" && method.active);
  const {
    handlePlaceOrder,
    isPending,
    isPayfort,
    payFortDetails,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    beginPlaceOrder,
    isApplePay
  } = usePayment(selectedAddress, cart, locale, paymentMethods, isCkoPayWithFlow);

  // Below useEffect is to submit the form programmatically for PayFort after receiving data
  useEffect(() => {
    let isMounted = true;
    if (payFortDetails) {
      // Submit the form when payFortDetails is fully populated
      formRef.current.submit();
    }
    return () => {
      isMounted = false;
    };
  }, [payFortDetails]);
  return <>
      <SectionHeading title={t("Payment")} data-sentry-element="SectionHeading" data-sentry-source-file="CheckoutPayment.jsx" />
      <div className="border-supportiveDarkGray md:mt-3 md:border">
        {Object.keys(cartRule || {}).length > 0 && <ShippingTag shippingFee={cartTotal?.shippingCharges} cartRule={cartRule} t={t} />}
        <div className="py-4 md:px-4">
          {/* Dynamically render payment options based on the selected payment method, if checkout.com payment gateway is enabled the render CheckoutOptionCKO or common CheckoutPaymentOptions*/}
          {isCkoPayWithFlow ? <CheckoutOptionCKO cart={cart} selectedAddress={selectedAddress} locale={locale} beginPlaceOrder={beginPlaceOrder} /> : <CheckoutPaymentOptions selectedPaymentMethod={selectedPaymentMethod} setSelectedPaymentMethod={setSelectedPaymentMethod} paymentMethods={paymentMethods} />}
        </div>
        <div className="text-end md:px-4">
          <form method={isPayfort ? "POST" : "GET"} action={isPayfort ? payFortDetails?.url : ""} ref={formRef} onSubmit={!isPayfort ? handlePlaceOrder : undefined}>
            {/* Dynamically render hidden fields for PayFort */}
            {isPayfort && payFortDetails && <PayFortForm payFortDetails={payFortDetails} />}
            {/* Render Apple Pay button if available on selecting payment method */}
            <ApplePayButton locale={locale} isApplePay={isApplePay} handlePlaceOrder={handlePlaceOrder} data-sentry-element="ApplePayButton" data-sentry-source-file="CheckoutPayment.jsx" />
            {!isCkoPayWithFlow && !isApplePay && <StickyButtonWrapper>
                <Button size="md" type={isPayfort ? "button" : "submit"} variant="primary" className={cx("relative min-w-full md:min-w-[205px]", {
              "ms-auto flex justify-center": isPending
            })} disabled={isPending} onClick={isPayfort ? handlePlaceOrder : undefined}>
                  {isPending ? <LoadingDots className="bg-black" /> : <span className={cx("flex items-center justify-center font-semibold", {
                "invisible leading-[0]": isPending
              })}>
                      {t("Pay")}
                      <span className="px-1">
                        <CurrencySymbol value={cartTotal?.formattedTotal} variant="smallSpecial" />
                      </span>
                      <IconForwardArrow className="ms-2 text-inherit rtl:rotate-180" />
                    </span>}
                </Button>
              </StickyButtonWrapper>}
          </form>
        </div>
      </div>
    </>;
};
export default CheckoutPayment;